import { ReactElement } from 'react';
import { Field } from 'formik';
import { TileRadio } from '@components';
import { tile } from '@interfaces/interfaces';
import gridStyle from '@pages/forms/Grid.module.scss';
import styles from './TPStep1.module.scss';

function TPStep1(): ReactElement {
  const LimitedAuthBody = (): ReactElement => (
    <div className={styles.body}>
      <div>Authority to Communicate</div>
      <div className={styles.desc}>Authorise a person to make enquiries and discuss your fines</div>
    </div>
  );

  const FullAuthBody = (): ReactElement => (
    <div className={styles.body}>
      <div>Authority to Act</div>
      <div className={styles.desc}>
        <div>
          <p>Authorise a person to discuss, act and make decisions on your behalf, such as:</p>
          <ul>
            <li>request a review of your fine </li>
            <li>apply for an extension of time or a payment arrangement</li>
            <li>update your contact details</li>
          </ul>
          <p>
            For more information about what an authorised person can do see
            <span> </span>
            <a href="https://online.fines.vic.gov.au/Support/Authorise-another-person-to-help-manage-your-fines" target="_blank" aria-label="link to" rel="noreferrer">
              Third party authorisation
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );

  const TILE_DATA: tile[] = [
    {
      body: <FullAuthBody />,
      value: 'Authority to Act',
    },
    {
      body: <LimitedAuthBody />,
      value: 'Authority to Communicate',
    },
  ];

  return (
    <section className={gridStyle.form}>
      <div className="vfH2">What type of authorisation would you like?</div>
      <Field name="WhatDoesThisAuthorisationCover" component={TileRadio} tileData={TILE_DATA} classname={styles.tile} />
    </section>
  );
}

export default TPStep1;
